/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon16Light = forwardRef('ArrowDCornerRightUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.354 6.146a.5.5 0 0 1-.708.708L10 3.207V11.5A2.5 2.5 0 0 1 7.5 14h-6a.5.5 0 1 1 0-1h6A1.5 1.5 0 0 0 9 11.5V3.207L5.354 6.854a.5.5 0 1 1-.708-.708l3.652-3.651a1.7 1.7 0 0 1 2.404 0l3.652 3.651Z" })));
});
